<app-aggregated-amount-item
  name="フィジカル売上枚数（NET）"
  icon="./assets/universal_music.png"
  amount="{{ (physicalShipmentCountModel$ | async)?.units }}"
  [hasAmount]="(physicalShipmentCountModel$ | async)?.hasUnits"
  unit="出荷数"
  [rate]="(physicalShipmentCountModel$ | async)?.rate"
  link=""
  help="{{
    (selectedArtist$ | async).nameMain
  }}のフィジカル売上枚数（NET）です。フィジカル売上枚数（NET）は選択期間の合計数です。"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
